import { render, staticRenderFns } from "./TutorialOnboarding.vue?vue&type=template&id=fa7d6af2"
import script from "./TutorialOnboarding.vue?vue&type=script&lang=ts"
export * from "./TutorialOnboarding.vue?vue&type=script&lang=ts"
import style0 from "./TutorialOnboarding.vue?vue&type=style&index=0&id=fa7d6af2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports